<nb-card>
  <nb-card-body *ngIf="patient">
    <nb-toggle status="primary" [checked]="patient.enableMacroGoals" (checkedChange)="onEnableMacroChange($event)"
      >Enable Macro Goals</nb-toggle
    > <div class="howto" style="position: absolute; height: 25px;">Beta</div>
    <nb-card [nbSpinner]="loading" [hidden]="!patient.enableMacroGoals">
      <nb-card-header>Goals</nb-card-header>
      <nb-card-body>
        <div class="d-flex mb-2 align-items-center">
          <nb-checkbox
            status="primary"
            [checked]="patient.autoFillFromPlan"
            (checkedChange)="onAutoFillChange($event)"
            [disabled]="!autoMacroGoals"
          >
            Automatically calculate macro goals based on active meal plan (update daily).
          </nb-checkbox>
          <nb-icon *ngIf="!autoMacroGoals" class="mx-1" icon="alert-circle-outline" nbTooltip="{{ ERROR_NO_ACTIVE_PLAN }}"></nb-icon>
        </div>
        <div class="macro-goals-container">
          <div class="macro-goals-form">
            <div>
              <label>Calories</label>
              <input
                nbInput
                class="input-box"
                type="number"
                fieldSize="small"
                pattern="[0-9]*"
                [(ngModel)]="patient.calories"
                [readOnly]="patient.autoFillFromPlan"
                (change)="onDirty()"
              />
            </div>
            <div>
              <label>Proteins</label>
              <input
                nbInput
                class="input-box"
                type="number"
                fieldSize="small"
                [(ngModel)]="patient.protein"
                [readOnly]="patient.autoFillFromPlan"
                (change)="onDirty()"
              />
              <span>&ensp;%&ensp;({{ MealProtein }}&ensp;g.)</span>
            </div>
            <div>
              <label>Carbs</label>
              <input
                nbInput
                class="input-box"
                type="number"
                fieldSize="small"
                [(ngModel)]="patient.carbs"
                [readOnly]="patient.autoFillFromPlan"
                (change)="onDirty()"
              />
              <span>&ensp;%&ensp;({{ MealCarbs }}&ensp;g.)</span>
            </div>
            <div>
              <label>Fats</label>
              <input
                nbInput
                class="input-box"
                type="number"
                fieldSize="small"
                [(ngModel)]="patient.fats"
                [readOnly]="patient.autoFillFromPlan"
                (change)="onDirty()"
              />
              <span>&ensp;%&ensp;({{ MealFats }}&ensp;g.)</span>
            </div>
          </div>
          <div>
            <ng-container>
              <app-meal-metrics-graph
                [MealCals]="MealCals"
                [MealProtein]="MealProtein"
                [MealCarbs]="MealCarbs"
                [MealNetCarbs]="MealNetCarbs"
                [MealFats]="MealFats"
                [GraphInBack]="true"
                [ChartWidth]="'140px'"
                [ChartHeight]="'140px'"
              >
              </app-meal-metrics-graph>
            </ng-container>
          </div>
        </div>
      </nb-card-body>
      <nb-card-footer>
        <label *ngIf="!isMacros100Per" class="text-danger">Warning, macro total must equal too 100%</label><br>
        <button nbButton (click)="onSave()" [disabled]="!isMacros100Per"  class="btn-circle btn-xl btn-main">Save Goal</button></nb-card-footer
      >
    </nb-card>
  </nb-card-body>
</nb-card>
